const splitByUpperCase = (value: string): string =>
  ((value || '').match(/[A-Z][a-z]+/g) || []).join(' ');

export default splitByUpperCase;
